import CityPage from "../CityPage";

export default function Lemont() {
  return <CityPage slug="lemont" />;
}
